import { Box, Typography } from "@mui/material";

import { NavSection } from "./LeftNavDrawerV2";

export function SectionNavRow({ section, collapsed }: { section: NavSection; collapsed: boolean }) {
  const { title, textColor, sx } = section;
  if (collapsed) {
    return (
      <Box
        sx={{
          px: 2,
          py: 1.5,
        }}
      >
        <Box
          sx={{
            height: "1px",
            width: "100%",
            backgroundColor: textColor ?? "#596376",
            opacity: textColor ? 0.5 : 1,
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        pl: "16px",
        pr: "4px",
        py: "12px",
        pb: "0px",
        ...sx,
      }}
    >
      <Typography
        sx={{
          color: textColor ?? "white",
          fontSize: "12px",
          fontWeight: 400,
          fontStyle: "normal",
          lineHeight: "24px",
          letterSpacing: "1px",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          flex: 1,
          height: "2px",
          backgroundColor: textColor ?? "#878D99",
          minWidth: 0,
        }}
      />
    </Box>
  );
}
